import React, { useState } from 'react';

import {
  OrganizationOnboardingType,
  OrganizationPublisherOnboardingType,
} from '@ts/userOrganization.types';
import { Button } from '@uikit/Form/Button/Button';

type Props = {
  details?: OrganizationOnboardingType;
  onSave: (details: Partial<OrganizationPublisherOnboardingType>, isCompleted: boolean) => void;
  onBack?: () => void;
  onContinue?: () => void;
};

function OnboardingPublisherCompanyType({
  details,
  onSave,
  onBack,
  onContinue,
}: Props): JSX.Element {
  const [value, setValue] = useState<string>(details?.publisher?.brandManagementType || '');

  const handleContinue = () => {
    if (!value) return;
    onSave({ brandManagementType: value }, false);
    onContinue && onContinue();
  };

  return (
    <div className="onboarding-step__one onboarding-step">
      <h2 className="onboarding-step__title">How does your company operate?</h2>
      <div className="onboarding-step__content">
        <div className="onboarding-step__options">
          <div
            className={`onboarding-option onboarding-option--big ${value === 'own' ? 'selected' : ''}`}
            onClick={() => setValue('own')}
          >
            <div className="onboarding-option__title">Own website(s)</div>
            <div className="onboarding-option__subtitle">
              We manage and operate our own publications.
            </div>
          </div>

          <div
            className={`onboarding-option onboarding-option--big ${value === 'reseller' ? 'selected' : ''}`}
            onClick={() => setValue('reseller')}
          >
            <div className="onboarding-option__title">Reseller</div>
            <div className="onboarding-option__subtitle">
              We resell articles from different publications.
            </div>
          </div>
        </div>
      </div>

      <div className="onboarding-step__footer">
        <Button type="secondary" onClick={onBack}>
          Back
        </Button>
        <Button disabled={!value} onClick={handleContinue}>
          Continue
        </Button>
      </div>
    </div>
  );
}

export default OnboardingPublisherCompanyType;
